import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import MonitoringPropertyListSF from '../../../components/superUser/loan/MonitoringPropertyListSF'

const LoanMonitoringPageUI = ({ context, errorList, loan, onRefreshClick }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_mntr' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.shortName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='monitoring'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <MonitoringPropertyListSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
    }
  </SuperUserLoanPageUI>

export default LoanMonitoringPageUI
